<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">inventory_2</i>
				</div>
				<h3 class="card-title">{{ title }}</h3>
			</div>
			<div class="card-body" *ngIf="viewing">
				<div class="table">
					<table class="table">
						<tr>
							<th>Order#</th>
							<th>Vendor</th>
							<th>Date</th>
							<th>Ordered</th>
							<th>Received</th>
							<th>Remaining</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.orderno }}</td>
							<td>{{ v.supplierid }}</td>
							<td>{{ v.orddate }}</td>
							<td>{{ v.ordered }}</td>
							<td>{{ v.rec }}</td>
							<td>{{ getRemaining(v.ordered, v.rec) }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(data, title)">
					<i class="material-icons">inventory_2</i>
				</div>
				<p class="card-category">{{ title }}</p>
				<h3 class="card-title">
					<span *ngIf="data">
						{{ data.length }}
					</span>
					<span *ngIf="!data">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(data, title)">
						<i class="material-icons">content_copy</i>
						View Now</a>
				</div>
				<br />
			</div>
		</div>
	</div>
</div>









